import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private config: any;

    constructor(private http: HttpClient) { }

    loadConfig(): Promise<any> {
        return firstValueFrom(this.http.get('assets/config.json'))
            .then(config => {
                this.config = config;
                return config;
            })
            .catch((err) => {
                console.error('Error loading config', err);
                return null;
            });
    }

   
    
    
}
